export const AuthenticationFailureMessageBoxStyles = {
  container: 'w-full flex flex-col items-center justify-center py-8 mt-auto',
  contactInfoContainer: 'flex flex-col items-start justify-center',
  icon: 'mr-5',
  email: 'flex flex-row items-center mt-6',
  phone: 'flex flex-row items-center mt-6',
  paragraph: 'text-black',
}
